export const SUBMITTAL_STATUS = {
  DRAFT: 'DRAFT',
  PENDING_REVIEW: 'PENDING_REVIEW',
  REJECTED: 'REJECTED',
  REPLACED: 'REPLACED',
  APPROVED: 'APPROVED',
  DELETED: 'DELETED',
  PASSED_DEADLINE: 'PASSED_DEADLINE',
}

export const SUBMITTAL_STATUS_LABEL = {
  [SUBMITTAL_STATUS.DRAFT]: 'Draft',
  [SUBMITTAL_STATUS.PENDING_REVIEW]: 'Pending Review',
  [SUBMITTAL_STATUS.REJECTED]: 'Rejected',
  [SUBMITTAL_STATUS.REPLACED]: 'Replaced',
  [SUBMITTAL_STATUS.APPROVED]: 'Approved',
  [SUBMITTAL_STATUS.DELETED]: 'Deleted',
  [SUBMITTAL_STATUS.PASSED_DEADLINE]: 'Passed Deadline',
}

export const SUBMITTAL_STATUS_PILL_MODIFIER = {
  [SUBMITTAL_STATUS.DRAFT]: 'draft',
  [SUBMITTAL_STATUS.PENDING_REVIEW]: 'pending-review',
  [SUBMITTAL_STATUS.REJECTED]: 'rejected',
  [SUBMITTAL_STATUS.REPLACED]: 'replaced',
  [SUBMITTAL_STATUS.APPROVED]: 'approved',
  [SUBMITTAL_STATUS.DELETED]: 'deleted',
  [SUBMITTAL_STATUS.PASSED_DEADLINE]: 'passed-deadline',
}
